import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';
import { useCalidad } from './CalidadContext';

export default function CalidadSelectorCorrida() {
    const {
        selectedFecha, setSelectedFecha,
        areas,
        lineas,
        corridas,
        selectedArea, setSelectedArea,
        selectedLinea, setSelectedLinea,
        selectedCorrida, setSelectedCorrida,
    } = useCalidad();

    const handleAreaChange = (e) => {
        const val = e.target.value;
        const area = val !== '' ? areas.find((a) => String(a.area) === String(val)) || null : null;
        setSelectedArea(area);
    };

    const handleLineaChange = (e) => {
        const val = e.target.value;
        const linea = val !== '' ? lineas.find((l) => String(l.id) === String(val)) || null : null;
        setSelectedLinea(linea);
    };

    const handleCorridaChange = (e) => {
        const val = e.target.value;
        if (val === '') {
            setSelectedCorrida(null);
            return;
        }
        const corrida = corridas.find((c) => String(c.corrida ?? c.id) === String(val)) || null;
        setSelectedCorrida(corrida);
    };

    const corridaValue = selectedCorrida ? String(selectedCorrida.corrida ?? selectedCorrida.id) : '';

    const formatCorridaLabel = (c) => {
        const id = c.corrida ?? c.id;
        const operador = c.operador || '';
        return operador ? `C-${id} | ${operador}` : `C-${id}`;
    };

    return (
        <div className="calidad-selector">
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                    variant="inline"
                    label="Fecha"
                    format="dd/MM/yyyy"
                    value={selectedFecha}
                    onChange={(date) => setSelectedFecha(date)}
                    autoOk
                    KeyboardButtonProps={{ 'aria-label': 'cambiar fecha' }}
                    className="calidad-selector-item calidad-selector-item--fecha"
                />
            </MuiPickersUtilsProvider>

            <FormControl className="calidad-selector-item">
                <InputLabel id="calidad-select-area-label">Área</InputLabel>
                <Select
                    labelId="calidad-select-area-label"
                    value={selectedArea?.area ?? ''}
                    onChange={handleAreaChange}
                >
                    <MenuItem value=""><em>Selecciona un área</em></MenuItem>
                    {areas.map((a) => (
                        <MenuItem key={a.area} value={a.area}>
                            {a.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {selectedArea && (
                <FormControl className="calidad-selector-item">
                    <InputLabel id="calidad-select-linea-label">Línea</InputLabel>
                    <Select
                        labelId="calidad-select-linea-label"
                        value={selectedLinea?.id ?? ''}
                        onChange={handleLineaChange}
                    >
                        <MenuItem value=""><em>Selecciona una línea</em></MenuItem>
                        {lineas.map((linea) => (
                            <MenuItem key={linea.id} value={linea.id}>
                                {linea.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {selectedLinea && (
                <FormControl className="calidad-selector-item calidad-selector-item--corrida">
                    <InputLabel id="calidad-select-corrida-label">Corrida</InputLabel>
                    <Select
                        labelId="calidad-select-corrida-label"
                        value={corridaValue}
                        onChange={handleCorridaChange}
                    >
                        <MenuItem value=""><em>Selecciona una corrida</em></MenuItem>
                        {corridas.map((c) => {
                            const id = String(c.corrida ?? c.id);
                            return (
                                <MenuItem key={id} value={id}>
                                    {formatCorridaLabel(c)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            )}
        </div>
    );
}
